<template>
  <div
    v-if="
      unleash.isEnabled('SalonizedPay') &&
      !(unleash.isEnabled('BlackFridayOffer') || unleash.isEnabled('FreeTerminalOffer')) &&
      adyenAppStateLoaded &&
      !adyenAppState.industryCode &&
      isExistingUser &&
      !isUk
    "
  >
    <BaseVisualBanner
      :heading="$t('dashboard.salonized_pay_banner.heading')"
      imagePath="/img/salonized-pay/getting-paid.svg"
      theme="dark"
      :primaryAction="{
        text: $t('global.learn_more'),
        routerLink: { name: 'salonized-pay' }
      }"
      v-test="'salonized-pay-banner'"
    />
  </div>
</template>
<script
  lang="ts"
  setup
>
import dayjs from '@/dayjs';
import { useAdyenStore } from '@/stores/adyen';
import { useCompanyStore } from '@/stores/company';
import unleash from '@/unleash';

const { adyenAppState, adyenAppStateLoaded } = useAdyenStore();
const { company, isUk } = useCompanyStore();
const isExistingUser = computed(
  () => dayjs('2024-06-25').diff(dayjs(company.trialEndAt), 'day') > 0,
);
</script>
